import { FC } from 'react'

import { LoadingSpinner } from '../../../../../../@paco/components'

import { ShiftConceptViewModelOld } from '../../../../../../entities/ShiftConcept/ShiftConcept'
import { translate } from '../../../../../../helpers/translations/translator'
import ShiftConceptButton from '../ShiftConceptButton/ShiftConceptButton'

import './ShiftConceptButtonsList.scss'

interface ShiftConceptButtonsListProps {
    isLoading: boolean;
    shiftConcepts: ShiftConceptViewModelOld[];
    activeShiftConcept: ShiftConceptViewModelOld | null;
    onShiftConceptClick: (activeShiftConcept: ShiftConceptViewModelOld) => void;
}

const ShiftConceptButtonsList: FC<ShiftConceptButtonsListProps> = ({
    isLoading,
    shiftConcepts,
    activeShiftConcept,
    onShiftConceptClick,
}) => {
    if (isLoading) {
        return (
            <div className="shift-concept-buttons-list shift-buttons-list--loading">
                <LoadingSpinner
                    isSmall
                    className="shift-concept-buttons-list__loading-spinner"
                />
            </div>
        )
    }

    if (! shiftConcepts.length) {
        return (
            <div className="shift-concept-buttons-list">
                {translate('pages.shifts.noShiftsFound')}
            </div>
        )
    }

    return (
        <div className="shift-concept-buttons-list">
            {shiftConcepts.map((shiftConcept) => (
                <ShiftConceptButton
                    key={shiftConcept.id}
                    shiftConcept={shiftConcept}
                    onClick={onShiftConceptClick}
                    active={activeShiftConcept === shiftConcept}
                />
            ))}
        </div>
    )
}

export default ShiftConceptButtonsList
